<template>
	<div>
		{{ getFormattedData() }}
	</div>
</template>

<script>
import erm from '@/components/UIComponents/EventDataRenderers/EventRenderersMethods.js';

export default {
	name: 'VehicleAssignmentFailedRenderer',
	props: {
		eventType: {
			type: String,
			required: true,
		},
		eventData: {
			type: String,
			required: true,
		}
	},
	methods: {
		getFormattedData() {
			const reason = erm.getValueOutOfGivenKey('failReason', this.eventData);
			const translatedReason = erm.getTranslationForEventDescription(reason);
			return translatedReason ? translatedReason : this.eventData;
		}
	}
}
</script>